import React from 'react'
import Banner from '../components/Banner'

 function Parcours() {
    return (
  
      <div style={{width:'100vw', height:'100vh',  justifyContent:'center', paddingTop:60}}>
   <Banner title='PARCOURS'/>
         
  <div className='containerAbout'>
     
      <h2> Peintre Plasticienne / Designer Textile</h2>
      <p>
        Née en 1961 à Tanger au MAROC, vit et travaille à PARIS depuis 1979</p>
    
    <h2> Etudes artistiques</h2>
    <p>
        1979 : Atelier Met de Penninghem et Jacques d’Andon (PARIS)
        <br/>
        
        1982 : Ecole Nationale Supérieure des Beaux-Arts (PARIS)
        <br/>
        1986 : Université PARIS-VIII (SAINT-DENIS)
        {/* <br/>
        1989 : IUFM d’ANTHONY (92) */}

    </p>

    {/* <h2>Diplômes</h2>
    <p>
        Juin 1986: Diplôme de l’Ecole Nationale Supérieure des Beaux-Arts de PARIS
        <br/>
        (Atelier ISCAN, dominante dessin)
        <br/>
        Juin 1987 : Licence Arts-Plastique . PARIS VIII
        <br/>
        Juillet 1991 : Diplôme de l’institut de formation des maîtres au Professorat des Ecoles
        <br/>
        (Inspection Académique de NANTERRE)
    </p> */}

<h2>Entrepreneuriat : Designer Textile</h2>
<p>
    Mars 2013 :Création d’entreprise : motifs et teintures sur tissus, objets textiles
pour l’ameublement et la décoration intérieure
    <br/>
    
</p>


    <h2>Expositions : Peintre Plasticienne</h2>
    <p>
    2012/2023 : Expositions Salons des Créateurs : Paris : Hauts de Seine et Province
    <br/>

    2012/2023 : Creation du film  Colored way  (film peint sur pellicule transparente 16mn)
    <br/>
    Presentation du film : Université paris VIII et l'ART EN PARTAGE
    <br/>
    

    2011 : ArAnima : Artistes Animaliers, Galerie HIP (PAIS 75)
    <br/>
   

Grand Marché de l'Art Contemporain à Bastille (PARIS 75)
<br/>

Atelier Porte Ouverte (VANVES 92)
    <br/>


    2010 : « Soirées Poétiques » Festival Art Danthé (VANVES 92)
    <br/>
    Exposition Universelle de Shangaï, Pavillon Francophone (CHINE)
    <br/>
        
        2009 : « Ateliers portes Ouvertes » (VANVES 92) - Journées du Patrimoine (VANVES 92) - Grand Marché de l’Art Contemporain à Bastille (PARIS 75) - Salon National des Artistes Animaliers (BRY SUR MARNE 94)
        <br/>
        
        2008 : « Atelier Porte Ouverte » (14 décembre 2008)
        <br/>
        
        2007 : Galerie ARTIVITé Patrick DELGADO (Avenue de Suffren, PARIS 15ème)
       
        
        : « Ateliers Portes Ouvertes » (12 mai 2007)

        <br/>
        
        2004/2006 : Plusieurs expositions collectives à PARIS et en Ile de France
        <br/>
        
        2003 : Galerie du Théâtre. VANVES (92)
        <br/>
        
        2002 : Sélectionnée ( Salon de Montrouge) pour représenter la FRANCE
        
        
        dans le cade des Rencontres Européennes (Ministère de la Culture) et exposer
        
        à San Cugat Del Vallés en ESPAGNE et au Musée National de Porto au
        
        PORTUGAL
        <br/>
        
        2001 : Galerie Quai 17. ROYAN
        
        Salon de Mai, espace Auteuil. PARIS
      
        
        Salon de Montrouge (1er Prix de la Jeune Peinture)
        <br/>
        
        2000 : Salon de l’Art Contemporain. VANVES
        <br/>
        
        1999 : Galerie Art-Moon. PONSONBY, NOUVELLE-ZELANDE
        <br/>
        
        1998 : Marché de l’Art. PARIS
        <br/>
        
        1997 : Les ateliers de la Bastille. PARIS
        <br/>
        
        1995 : Week-end des plasticiens. SAINT-DENIS
        <br/>
        
        1993 : Biennale des Femmes (Grand-Palais). PARIS
        <br/>
        
        1992 : Salon de Mai. PARIS
        <br/>
        
        1990 : Journées Portes ouvertes. Bastille, PARIS
        <br/>
        
        1989 : Galerie du Théâtre. VANVES (92)
        <br/>
        
        1987 : « Contacts ». Université de PARIS-VIII
        <br/>
        
        1986 : Salon de BAGNEUX
        <br/>
        
        1985 : Galerie des Beaux-Arts. PARIS

        
        Galerie du CNRS. ORSAY
        <br/>
        
        1982 : Salon des Indépendants (Grand-Palais). PARIS
    </p>


    <h2>ARTICLES DANS LA PRESSE</h2>
    <p>
        Avril 2010 : - LIGEIA (Dossiers sur l’art), N° : 97.98.99.100
        Auteurs: Giovanni LISTA, Mario GUASTONNI
        <b>« Catherine THOMAS, un thème formel »</b>
        <br/>
        <br/>
        
        Novembre 2008: - La gazette des tortues (article en ligne)
        <br/>
        Bernard ROUJON: journaliste,
        <br/>
    
        
        « Inauguration de la nouvelle chronique: Catherine THOMAS »
        <br/>
        <br/>
        
        Mars 2007 : - Noé Conservation (article en ligne)
        <br/>
        Vanves, Infos (magazine municipal)
        <br/>
        Vanessa Faisant : journaliste,
        
        « Les tortues sont à l’image de mon existence… »
        <br/>
        <br/>
        
        Août 2001 : - Vanves, Infos (magazine municipal) N° 144
        <br/>
        Bernard GAUDUCHEAU : directeur de la publication, «  Portrait »
        <br/>
        <br/>
        
        Janvier 2001 : - Les Saisons de la Danse N° 336
        <br/>
        Philippe VERRIELE : directeur de la publication,
        <br/>
        « le corps des Vénus »
        <br/>
        <br/>
        
        Octobre 2000 : - LIGEIA (Dossiers sur l’art), N° : 33.34.35.36
        <br/>
        Mario GUASTONI : rédacteur en chef, « L ’ homme et l’espace »
        <br/>
        <br/>
        
        <h2>DIVERS (réalisations):</h2>
        
        
        Décembre 2008: - Films documentaires (14′+ 5′) VF + VA
        <br/>
        Réalisation: Valérie LUMBROSO
        <br/>
        «  Turtles- Catherine THOMAS »
        <br/><br/>
        
        Juin 2006: - Mosaïque dans la cour de l’école Voltaire (Issy Ls Moulineaux 92)
        <br/>
        Sponsor: Société Patrick FILLIOL (entreprise de carrelages)
        <br/>
        « Enfances » (120X700)
        <br/><br/>
        Mars 1999: - CD audio (7′) + textes
        <br/>
        Réalisation sonore: Régis VIOGEAT
        <br/>
        «  Le Prince et la goutte d’eau »
        <br/><br/>
        Février 1998: - CD Rom (10′) textes + images
        <br/>
        Conception numérique: Philippe VERNIER
        <br/>
        «  Païkéa, l’enfant Maori »
    </p>

    
<div>
        

        
        
        
        
            </div>
  
  
  </div>
  
  
  
  
      </div>
     
    )
  }
  


export default Parcours